// Utilitário para gerar tokens de autenticação
// Agora o JWT é gerado no backend por segurança

import { REACT_APP_DISCORD_BOT_ENDPOINT } from '../config/constants';

// Função para gerar token de autenticação via backend
export async function generateAuthToken(userData) {
  try {
    const response = await fetch(REACT_APP_DISCORD_BOT_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        command: 'auth',
        function: 'generateToken',
        userData: userData
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    if (data.error) {
      throw new Error(data.error);
    }

    return data.token;
  } catch (error) {
    console.error('Erro ao gerar token:', error);
    throw error;
  }
}

// Função para verificar se o token ainda é válido
export function isTokenValid(token) {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return false;
    
    const payload = JSON.parse(atob(parts[1]));
    const now = Math.floor(Date.now() / 1000);
    
    return payload.exp > now;
  } catch (error) {
    console.error('Erro ao verificar token:', error);
    return false;
  }
}

// Função para extrair dados do token
export function getTokenData(token) {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    
    return JSON.parse(atob(parts[1]));
  } catch (error) {
    console.error('Erro ao extrair dados do token:', error);
    return null;
  }
} 